package com.bikompanion.domain

/**
 * What a rider can flag when a bike gets a thumbs-down.
 *
 * The electric-only entries are meaningful only when the vote also says the bike is electric —
 * the UI is what decides to hide them otherwise, this is just the full set worth tracking.
 */
enum class BikeIssue {
    FlatTire,
    FrontBrakeNotWorking,
    RearBrakeNotWorking,
    ChainSlipping,
    GearsNotShifting,
    SeatDamagedOrMissing,
    LightsNotWorking,
    LockOrBasketDamaged,
    FrameDamage,
    ElectricMotorNotWorking,
    BatteryNotCharging,
    Other,
}

val ElectricOnlyIssues = setOf(BikeIssue.ElectricMotorNotWorking, BikeIssue.BatteryNotCharging)
